import { FooterBreadcrumbs } from "./footer-breadcrums"
import { FooterSocket } from "./footer-socket"
import React from "react"
import { getFooterComponent } from "./utils"
import { getFooterData } from "data/footer"

export const Footer = ({ page, breadcrumb_array }) => {
  const footer_content = getFooterData[page || "ueber-uns"]?.map(
    (item, index) => (item = { ...item, react_key: index })
  )

  return (
    <div data-nosnippet>
      <footer>
        {!!breadcrumb_array?.[0] ? (
          <FooterBreadcrumbs {...{ breadcrumb_array }} />
        ) : null}
        <div className="hero is-mitternachtsblau">
          <div className="hero-body">
            <div className="container">
              <div className="columns is-centered is-variable is-6">
                {footer_content.map(getFooterComponent)}
              </div>
            </div>
          </div>
        </div>
        <FooterSocket />
      </footer>
    </div>
  )
}
